import type { Decimal } from '~/composables/support/decimal'
import type { BillingInterval } from '~/resources/graphql/graphql'
import { useI18n } from 'vue-i18n'

// Turn to `price /billingInterval` string format
// Used for contract questions displays
export function formatRecurringTotalString(
    price: Decimal,
    billingInterval: BillingInterval
) {
    const { t } = useI18n()
    let formatted = price.formatCurrency()
    if (billingInterval === 'DAILY') {
        formatted += t('billing.perDay')
    } else if (billingInterval === 'WEEKLY') {
        formatted += t('billing.perWeek')
    } else if (billingInterval === 'FORTNIGHTLY') {
        formatted += t('billing.perFortnight')
    } else if (billingInterval === 'MONTHLY') {
        formatted += t('billing.perMonth')
    } else if (billingInterval === 'QUARTERLY') {
        formatted += t('billing.perQuarter')
    } else if (billingInterval === 'YEARLY') {
        formatted += t('billing.perYear')
    } else {
        throw new Error('Unsupported billing interval')
    }
    return formatted
}
